<template>
  <el-dialog :visible.sync="visible" title="Surrogate Assessor Details" width="60%">
    <div class="form-group">
      <div class="box-row">
        <div class="box-col box-col-left">Name</div>
        <div class="box-col-right">
          <el-input type="text" v-model="curItem.SurrogateAssessorName" placeholder="SurrogateAssessor Name"/>
          <div v-if="hasError && interpreterNameError" class="text-danger">{{ interpreterNameError }}</div>
        </div>
      </div>
      <div class="box-row">
        <div class="box-col box-col-left">Company Name</div>
        <div class="box-col-right">
          <el-input type="text" v-model="curItem.SurrogateAssessorCompanyName" placeholder="SurrogateAssessor Company Name"/>
          <div v-if="hasError && interpreterCompanyError" class="text-danger">{{ interpreterCompanyError }}</div>
        </div>
      </div>
      <div class="box-row">
        <div class="box-col box-col-left">Contact Number</div>
        <div class="box-col-right">
          <el-input @blur="trimField('SurrogateAssessorContactNumber')" type="text" v-model="curItem.SurrogateAssessorContactNumber" placeholder="SurrogateAssessor Contact Number"/>
          <div v-if="hasError && interpreterPhoneError" class="text-danger">{{ interpreterPhoneError }}</div>
        </div>
      </div>
      <div class="box-row">
        <div class="box-col box-col-left">Contact Email</div>
        <div class="box-col-right">
          <el-input type="text" v-model="curItem.SurrogateAssessorContactEmail" placeholder="SurrogateAssessor Contact Email"/>
          <div v-if="hasError && interpreterEmailError" class="text-danger">{{ interpreterEmailError }}</div>
        </div>
      </div>
      <div class="box-row">
        <div class="box-col box-col-left">Cost</div>
        <div class="box-col-right">
          <el-input-number :precision="0" class="w-100" v-model="curItem.SurrogateAssessorCost" placeholder="SurrogateAssessor Cost" controls-position="right" ></el-input-number>
          <div v-if="hasError && interpreterCostError" class="text-danger">{{ interpreterCostError }}</div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <v-btn @click="clickSave" dark>Save</v-btn>
      <v-btn class="white-button ml-4" @click="visible = false" dark>Cancel</v-btn>
    </div>
  </el-dialog>
</template>
<script>
import utilities from "../../assets/js/utilities";

export default {
  name: 'ConfirmDialog',
  data() {
    return {
      visible: false,
      curItem: {},
      hasError: false
    }
  },
  methods: {
    trimField(key) {
      const v = this.curItem[key]
      if (v === undefined || v === null || typeof v !== 'string') {
        return
      }
      this.$set(this.curItem, key, utilities.normalizeAuPhoneInput(v))
    },
    clickSave() {
      this.hasError = false
      if(this.interpreterNameError || this.interpreterCompanyError || this.interpreterPhoneError || this.interpreterCostError || this.interpreterEmailError) {
        this.hasError = true
        return
      }
      this.$emit('clickSave', this.curItem)
      this.visible = false
    }
  },
  computed: {
    interpreterNameError() {
      return utilities.getAdminBookingInterpreterNameError(this.curItem.SurrogateAssessorName)
    },
    interpreterCompanyError() {
      return utilities.getAdminBookingInterpreterCompanyError(this.curItem.SurrogateAssessorCompanyName)
    },
    interpreterPhoneError() {
      return utilities.getLandPhoneError(this.curItem.SurrogateAssessorContactNumber)
    },
    interpreterEmailError() {
      return utilities.getAdminBookingInterpreterEmailError(this.curItem.SurrogateAssessorContactEmail)
    },
    interpreterCostError() {
      if (!this.user || this.user.type < 3) {
        return ''
      }
      return utilities.getAdminBookingInterpreterCostError(this.curItem.SurrogateAssessorCost)
    },
  }
}
</script>

<style scoped>

</style>
